import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const fileUrl = (id) => (id ? `${API}/files/${id}` : null);

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("acteio_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const company = localStorage.getItem("acteio_company");
  if (company) config.headers["X-Company"] = company;
  return config;
});

export function applyAccent(hsl) {
  const root = document.documentElement;
  if (!hsl) {
    // Pas de société active — retirer l'override pour laisser le CSS brand Acteio s'appliquer
    root.style.removeProperty("--primary");
    root.style.removeProperty("--ring");
    return;
  }
  root.style.setProperty("--primary", hsl);
  root.style.setProperty("--ring", hsl);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Extrait le message lisible d'une erreur axios (NestJS + fallback) */
export function formatAxiosError(err) {
  if (!err.response) return "Impossible de contacter le serveur. Vérifiez votre connexion.";
  const d = err.response.data;
  // NestJS: { message, statusCode }
  if (d?.message && typeof d.message === "string") return d.message;
  // FastAPI: { detail }
  const fromDetail = formatApiErrorDetail(d?.detail);
  if (fromDetail) return fromDetail;
  return `Erreur ${err.response.status}`;
}

const SAFE_REDIRECT_PREFIXES = [
  'https://checkout.stripe.com/',
  'https://billing.stripe.com/',
  'https://www.paypal.com/',
  'https://www.sandbox.paypal.com/',
];

export function safeRedirect(url) {
  if (!url || typeof url !== 'string') return;
  if (!SAFE_REDIRECT_PREFIXES.some((p) => url.startsWith(p))) {
    console.error('[SECURITY] Redirection bloquée vers une URL non whitelistée :', url);
    return;
  }
  window.location.href = url;
}

export function safeOpen(url) {
  if (!url || typeof url !== 'string') return;
  if (!SAFE_REDIRECT_PREFIXES.some((p) => url.startsWith(p))) {
    console.error('[SECURITY] window.open bloqué vers une URL non whitelistée :', url);
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
}

export const fmtMoney = (v, currency = "EUR") => {
  const n = v || 0;
  // Affiche les centimes uniquement s'ils existent : "89 €" reste net, "1,50 €" / "130,50 €" exacts.
  const hasCents = Math.round(n * 100) % 100 !== 0;
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency,
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(n);
};

export const STATUS_META = {
  "brouillon": { label: "Brouillon", color: "bg-muted text-muted-foreground border-border" },
  "envoyée": { label: "Envoyée", color: "bg-blue-50 text-blue-700 border-blue-200" },
  "vue": { label: "Vue", color: "bg-amber-50 text-amber-700 border-amber-200" },
  "acceptée": { label: "Acceptée", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "refusée": { label: "Refusée", color: "bg-rose-50 text-rose-700 border-rose-200" },
};

export default api;
